var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body min-h-100 overflow-x-hidden page-layout"},[_c('PageHeaderComponent',{staticClass:"position-relative w-100 mb-40"}),_vm._t("default"),_c('FooterComponent')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }